<template>
  <div>
    <mdb-row style="margin-bottom: -4rem;">
      <mdb-col md="3" class="card-div">
        <div class="title-style">
          Acciones
          <br />
          <div style="font-size: 16px; font-weight: lighter;; display: -webkit-box;">
            Total de acciones: &nbsp;
            <div class="circle-style">{{totalOfElements}}</div>
          </div>
        </div>
      </mdb-col>
      <mdb-col md="7" class="card-div searchBar">
        <input
          class="input-style"
          type="text"
          name="buscador"
          id="search"
          v-model="search"
          placeholder="Buscar por nombre de la accion"
        />
      </mdb-col>
      <mdb-col md="2" class="card-div">
        <div>
          <button class="btn buttonFilter" type="button" @click="showFilterUser = !showFilterUser">
            <img src="/img/icons/InoFiltrar.svg" alt="filtrar" />
          </button>
        </div>
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <table class="t1-table text-center">
        <tr>
          <th>Acción</th>
          <th>Numero de usuarios</th>
          <th>Precio</th>
          <th></th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in displayedPost" v-bind:key="index">
          <td class="text-center">{{item.applicationNumber}}</td>
          <td v-if="item.paymentStatus=='APPROVED'" class="text-center">Aprobado</td>
          <td v-else-if="item.paymentStatus=='REJECTED'" class="text-center">Rechazado</td>
          <td v-else class="text-center">Pendiente</td>
          <td class="text-center">{{item.date}}</td>
          <td>
            <button
              type="button"
              @click="getOneApplication(item.id, item.applicationStatus)"
              class="btn btn-edit"
              style="padding: 3px;"
            >
              <img :src="'/img/icons/pencil.svg'" alt="icon ver" />
            </button>
          </td>
          <td>
            <button
              type="button"
              @click="getOneApplication(item.id, item.applicationStatus)"
              class="btn btn-edit"
              style="padding: 3px;"
            >
              <img :src="'/img/icons/inoBorrar.svg'" alt="icon ver" />
            </button>
          </td>
        </tr>
      </table>
    </mdb-row>
    <mdb-row>
      <mdb-col></mdb-col>
      <mdb-col>
        <div class="selectdiv">
          <div>
            <nav style="position: absolute; right: 80%;">
              <ul class="t1-pagination">
                <li v-if="page != 1">
                  <a @click="page--">
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(90deg)" />
                  </a>
                </li>

                <li
                  :class="pageNumber==page? 't1-pagination--active':''"
                  v-for="pageNumber in pages.slice(page-1, page+3)"
                  :key="pageNumber"
                >
                  <a @click="page = pageNumber">{{pageNumber}}</a>
                </li>

                <li v-if="page < pages.length" @click="page++">
                  <a>
                    <img src="/img/icons/IconFlechaAbajo.svg" alt style="transform: rotate(270deg)" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div>
            <select name="pages" id="pages">
              <option value="1">Pag. 1</option>
              <option value="2">Pag. 2</option>
              <option value="3">Pag. 3</option>
            </select>
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row class="mt-5">
      <mdb-col></mdb-col>
      <mdb-col></mdb-col>
      <mdb-col>
        <div class="mt-5" style="position:absolute">
          <img class="btn-add-icon" src="/img/icons/icon-plus-circle.svg" />
          <div >
              <button class="btn-crear">Agregar Accion</button>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
  </div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import Swal from "sweetalert2";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";

export default {
  name: "Payments",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbCard,
    Btn,
    Popup,
    ValidationError
  },
  data() {
    return {
      totalOfElements: 0,
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      search: "",
      dataList: [],
      showFilterUser: false,
      search: ""
    };
  },
  methods: {
    ...mapActions(["getListOfPayments"]),
    async getPaymentsList() {
      let response = await this.getListOfPayments();
      if (response.data.data != null) {
        this.dataList = response.data.data;
        this.totalOfElements = this.dataList.length;
      } else {
        this.dataList = [];
        this.totalOfElements = 0;
      }
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / this.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    cleanDataTable() {
      this.totalOfElements = 0;
      this.page = 1;
      this.perPage = 15;
      this.pages = [];
      this.numberOfPages = 0;
      this.search = "";
      this.dataList = [];
    }
  },
  mounted() {
    this.cleanDataTable();
    this.getPaymentsList();
  },
  computed: {
    ...mapGetters({
      loginUserType: "getUserType"
    }),
    displayedPost() {
      return this.paginate(this.dataList);
    }
  }
};
</script>

<style>
.btn-crear {
  width: 15rem;
  height: 3rem;
  border-radius: 3.5px;
  background-color: #dc7134;
  color: #ffffff;
  font-size: 12px;
  bottom: 10px;
}
</style>